import { api, createCancelTokenHandler } from "../utils/services";
import { ENV } from "../constants";

const UserAssignAssetRepository = {
  assignAssets: function (
    id: number | string,
    payload: any,
    params: any = null
  ) {
    return api.post(
      `${ENV.getApiEndPoint()}/api/user/${id}/assign-assets`,
      payload,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[this.assignAssets.name].handleRequestCancellation()
            .token,
      }
    );
  },
};

const cancelTokenHandlerObject = createCancelTokenHandler(
  UserAssignAssetRepository
);

export default UserAssignAssetRepository;
